module.exports = __webpack_public_path__ + "static/media/beras.cc5a4efc.svg";